import { render } from "./TranslationExportView.vue?vue&type=template&id=4ab2de2e&scoped=true&ts=true"
import script from "./TranslationExportView.vue?vue&type=script&lang=ts"
export * from "./TranslationExportView.vue?vue&type=script&lang=ts"

import "./TranslationExportView.vue?vue&type=style&index=0&id=4ab2de2e&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4ab2de2e"]])

export default __exports__